/**
 * Allows user to provide a function to call on startup. If the DOM is already
 * loaded, the script runs immediately.
 * @param {Function} callback - Callback function to execute on startup
 */
export default function(callback) {
  if(document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', callback);
  } else {
    callback();
  }
}
